import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const AccordionItemWrapper = styled.div<{ $isOpen: boolean }>`
  &&& {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${({ $isOpen }) => $isOpen && `margin-bottom: ${pxToRem(24)} `}
  }
`;

export const AccordionItemWrapperContent = styled.div`
  &&& {
    padding: ${pxToRem(16)} ${pxToRem(24)};
  }
`;

export const AccordionDescription = styled.div`
  &&& {
    padding-bottom: ${pxToRem(24)};
  }
`;

export const AccordionLabelWrapper = styled.div`
  &&& {
    width: 100%;
  }
`;
